import React, { useState, useEffect } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { KnovaText } from '../BasicUIComponents/KnovaText'
import { FloatingSubmit } from '../UIUtilsFiles/FloatingSubmit'

function SCRTEComponent(props) {
  const {
    fromLayout,
    componentData,
    themeColors,
    isSideMenu,
    defaultValue,
    onValueChange
  } = props
  const { ControlID, Value, Editable, Priority } = componentData

  const [richTextValue, setRichTextValue] = useState('')
  const [initial, setInitial] = useState(true)
  const [displayDone, setDisplayDone] = useState(false)

  let modules = {
    toolbar: [
      // [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' }
      ],
      ['link', 'image']
      // ["clean"],
    ]
  }
  let modulesEmpty = {
    toolbar: false
  }

  let formats = [
    // 'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image'
  ]

  useEffect(() => {
    if (initial) {
      let contentBlock = ''
      if (defaultValue && defaultValue.CtlValue) {
        console.log('defaultValue', defaultValue)
        contentBlock = defaultValue.CtlValue.Answer
        setInitial(false)
      } else {
        contentBlock = Value
      }
      setRichTextValue(contentBlock)
    }
  }, [defaultValue, initial])

  function onEditorValueChange(editorValue) {
    setRichTextValue(editorValue)
    onValueChange(ControlID, { Answer: editorValue, Value: 0 }, 0, 0, [], false)
  }

  return (
    <div
      className='sc-richtext-cont'
      style={{
        borderWidth: fromLayout ? '2px' : '0px',
        borderStyle: fromLayout ? 'solid' : 'unset',
        borderColor: themeColors.outline,
        borderRadius: isSideMenu ? '5px' : fromLayout ? '12px' : '0px'
      }}
    >
      {!isSideMenu && (
        <ReactQuill
          id={ControlID}
          theme='snow'
          modules={Editable ? modules : modulesEmpty}
          formats={formats}
          // readOnly={
          //   Editable ? (completed === 0 && isActive ? false : true) : true
          // }
          onChange={(value) => {
            onEditorValueChange(value)
          }}
          defaultValue={richTextValue}
          value={richTextValue}
          placeholder='Text goes here'
        />
      )}
      {isSideMenu && (
        <KnovaText
          contMargin='5px'
          text='Text goes here'
          textFontSize='5px'
          textColor={themeColors.onBackgroundContainer}
          textOpacity={0.3}
        />
      )}
      {/* {isEmbeded && displayDone && Editable && (
        <FloatingSubmit
          submitClicked={() => {
            setDisplayDone(false)
            handleTextData()
          }}
        />
      )} */}
    </div>
  )
}

export default SCRTEComponent
